import React from "react"
import { Link } from "@chakra-ui/react"
import { Link as GatsbyLink } from "gatsby"

// Internal links route through Gatsby; external ones open in a new tab.
const MenuLink = ({ link, label = link.label, activeStyle, sx }) =>
  link.to ? (
    <Link as={GatsbyLink} to={link.to} activeStyle={activeStyle} sx={sx}>
      {label}
    </Link>
  ) : (
    <Link href={link.href} isExternal sx={sx}>
      {label}
    </Link>
  )

export default MenuLink
